import { useState } from "react";

export const useLocalStorage = (keyName, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(keyName);

      if (value) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue) => {
    try {
      window.localStorage.setItem(keyName, JSON.stringify(newValue));
    } catch (err) {}
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};


export const useLocalStorageWithExpiryDate = (keyName, defaultValue, expiryInMs = 24 * 60 * 60 * 1000) => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const itemStr = window.localStorage.getItem(keyName);
            if (!itemStr) {
                const newItem = {
                    value: defaultValue,
                    expiry: Date.now() + expiryInMs,
                };
                window.localStorage.setItem(keyName, JSON.stringify(newItem));
                return defaultValue;
            }

            const item = JSON.parse(itemStr);
            // Check expiry
            if (Date.now() > item.expiry) {
                window.localStorage.removeItem(keyName);

                const newItem = {
                    value: defaultValue,
                    expiry: Date.now() + expiryInMs,
                };
                window.localStorage.setItem(keyName, JSON.stringify(newItem));
                return defaultValue;
            }

            return item.value;
        } catch (err) {
            return defaultValue;
        }
    });

    const setValue = (value) => {
        const newValue = typeof value === "function" ? value(storedValue) : value;

        try {
            const existing = JSON.parse(window.localStorage.getItem(keyName));
            const expiry = existing?.expiry || Date.now() + expiryInMs;

            const newItem = {
                value: newValue,
                expiry,
            };

            window.localStorage.setItem(keyName, JSON.stringify(newItem));
        } catch (err) {}

        setStoredValue(newValue);
    };

    return [storedValue, setValue];
};

